import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { PdpSharedNotListedHeader } from '../PdpSharedNotListedHeader/PdpSharedNotListedHeader';
import { FollowSearchButton } from '../../components/global/FollowSearchButton/FollowSearchButton';

// helpers
import get from 'lodash.get';

// styles
import styles from './PdpRespNotListedContent.scss';

export const PdpRespNotListedContentComponent = ({ item, user }) => {
    return (
        <div className={styles.unlisted}>
            {/* Title */}
            <PdpSharedNotListedHeader item={item} additionalStyles={styles} />

            {/* Follow Search Button */}
            <div className={styles.followButton}>
                <FollowSearchButton
                    size="medium"
                    userId={get(user, 'serviceId')}
                    page={get(item, 'saveSearchData.page')}
                    name={get(item, 'saveSearchData.name')}
                    favoritesConnection={get(user, 'favorites') || null}
                />
            </div>
        </div>
    );
};

PdpRespNotListedContentComponent.propTypes = {
    additionalStyles: PropTypes.object,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export const PdpRespNotListedContent = createFragmentContainer(PdpRespNotListedContentComponent, {
    item: graphql`
        fragment PdpRespNotListedContent_item on Item {
            ...PdpSharedNotListedHeader_item
            saveSearchData {
                name
                page
            }
        }
    `,
    user: graphql`
        fragment PdpRespNotListedContent_user on User {
            serviceId
            favorites(first: 1, types: [SEARCH], pages: $followSearchPages)
                @include(if: $fetchFollowSearch) {
                ...FollowSearchButton_favoritesConnection
            }
        }
    `,
});
